import React from 'react';
import PackageCard from '../components/PackageCard';
import BeforeYouBook from '../components/BeforeYouBook';
import { Helmet } from 'react-helmet-async';
const AdditionalLessonsPage = () => {
  const additionalPackages = [{
    title: 'Refresher Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package designed for full licence holders.',
    features: ['Rebuild confidence after a break from driving', 'Update your skills with current best practices', 'Address specific driving anxieties or concerns', 'Personalized coaching based on your needs'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Motorway Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package for safe motorway driving.',
    features: ['Learn proper lane discipline and positioning', 'Practice safe entry and exit via slip roads', 'Develop skills for overtaking and speed management', 'Build confidence on high-speed roads'],
    popular: true,
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-429" data-mp="2a5vpf1jz9nmy">
      <Helmet data-id="element-430" data-mp="2a1y4qbhr4o0y">
        <title data-id="element-431" data-mp="255hffdytg3ma">Refresher & Motorway Driving Lessons Northampton</title>
        <meta name="description" content="Build confidence with refresher driving lessons and motorway lessons in Northampton. Affordable, local, and tailored to your needs." data-id="element-432" data-mp="257apl38n15z1" />
        <meta name="keywords" content="refresher driving lessons Northampton, motorway driving lessons Northampton, confidence building driving lessons, automatic driving lessons Northampton" data-id="element-433" data-mp="2f1krpcndtimy" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-434" data-mp="32sgchptf7dkp">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-435" data-mp="32qvl292ekar2">
          Additional Driving Lessons
        </h1>
        {/* Hidden H2 tags for SEO */}
        <h2 className="sr-only" data-id="element-436" data-mp="34xuwr2tcdbgf">Refresher Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-437" data-mp="39w67rgvdhs08">Motorway Driving Lessons Northampton</h2>
        <div className="mb-8" data-id="element-438" data-mp="39u3hqwu7zyvi">
          <p className="text-gray-700" data-id="element-439" data-mp="3evj2enshk3dd">
            Beyond our standard and intensive courses, we offer specialised
            driving lessons to help you build confidence in specific areas. All
            lessons are conducted in automatic cars by our qualified
            instructors.
          </p>
        </div>
        {/* Refresher Lessons Section */}
        <div className="mb-16" data-id="element-440" data-mp="3skuorrqqjd6q">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-441" data-mp="1gmfol6fufmr">
            Refresher Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-442" data-mp="6eek2eo9ru7u">
            <div data-id="element-443" data-mp="237zm5eo20vkx">
              <p className="mb-4" data-id="element-444" data-mp="238iz0gyukts3">
                Our refresher driving lessons are perfect for licensed drivers
                who haven't been behind the wheel for a while or who want to
                brush up on their skills. Whether you've lost confidence or
                simply need to update your knowledge of current road
                regulations, our patient instructors will help you become a
                confident driver again.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-445" data-mp="1lyf2lh59trgj">
                <h3 className="text-xl font-semibold mb-3" data-id="element-446" data-mp="1lzyjn9yr46jd">Who Can Benefit?</h3>
                <ul className="space-y-2" data-id="element-447" data-mp="2jkumsqp3137s">
                  <li className="flex items-start" data-id="element-448" data-mp="2jjt9sgoia6nf">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-449" data-mp="2eo455yxmpzk9">
                      ✓
                    </div>
                    <div data-id="element-450" data-mp="24o3ko9o0xdeh">Drivers who haven't driven for an extended period</div>
                  </li>
                  <li className="flex items-start" data-id="element-451" data-mp="y9m6nkonfjlx">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-452" data-mp="t9q1vj84no5b">
                      ✓
                    </div>
                    <div data-id="element-453" data-mp="2munl0uib28ht">
                      Those who've experienced a road incident and need to
                      rebuild confidence
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-454" data-mp="283wstlcsx7e6">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-455" data-mp="2d5m32ys79h17">
                      ✓
                    </div>
                    <div data-id="element-456" data-mp="35s6vm2kevz6c">
                      International license holders adapting to UK roads
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-457" data-mp="2vvbxhks1w0sl">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-458" data-mp="2vu0qzd780exs">
                      ✓
                    </div>
                    <div data-id="element-459" data-mp="1kgyccnoolzg9">
                      Drivers wanting to improve specific skills (parking,
                      roundabouts, etc.)
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-460" data-mp="bj894nwaage1">
              <PackageCard title="Refresher Driving Lessons" price="£90" description="£45 per hour - 2-hour package designed for full licence holders who want to rebuild confidence or update their skills." features={['Personalized to address your specific concerns', 'Focus on areas where you need most practice', 'Update on current road rules and regulations', 'Flexible scheduling to fit your availability']} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-461" data-mp="bjqeca0xc4y3" />
            </div>
          </div>
        </div>
        {/* Motorway Lessons Section */}
        <div className="mb-16" data-id="element-462" data-mp="2s7lx6s2dnawy">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-463" data-mp="v7hnvdvbjhg2">
            Motorway Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-464" data-mp="1059g68zvl5ks">
            <div data-id="element-465" data-mp="14xawc605zgg3">
              <p className="mb-4" data-id="element-466" data-mp="14wrjh3pdfi8x">
                Motorway driving requires specific skills and confidence that
                many new drivers haven't had the opportunity to develop. Our
                specialized motorway lessons provide a safe, structured
                environment to learn these essential skills with an experienced
                instructor by your side.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-467" data-mp="m5i62jchc9c2">
                <h3 className="text-xl font-semibold mb-3" data-id="element-468" data-mp="r5moiewy7e4x">
                  What You'll Learn
                </h3>
                <ul className="space-y-2" data-id="element-469" data-mp="1xlyn2h3omy11">
                  <li className="flex items-start" data-id="element-470" data-mp="1xl6t1apqh8cv">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-471" data-mp="22kjg9wkiohfz">
                      ✓
                    </div>
                    <div data-id="element-472" data-mp="3i3zdwfgnu4tv">Safe entry and exit via slip roads</div>
                  </li>
                  <li className="flex items-start" data-id="element-473" data-mp="3dd0xzgzl38r5">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-474" data-mp="3dbg3tsh6lrtt">
                      ✓
                    </div>
                    <div data-id="element-475" data-mp="33geeowmwopr8">Proper lane discipline and positioning</div>
                  </li>
                  <li className="flex items-start" data-id="element-476" data-mp="2zcgfklxkzey6">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-477" data-mp="2ue57afmxpci2">
                      ✓
                    </div>
                    <div data-id="element-478" data-mp="sms53yccpipp">Safe overtaking techniques</div>
                  </li>
                  <li className="flex items-start" data-id="element-479" data-mp="skpb7382v5fp">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-480" data-mp="noqix4jmp3a0">
                      ✓
                    </div>
                    <div data-id="element-481" data-mp="1geaind9tusg">Managing speed and maintaining safe distances</div>
                  </li>
                  <li className="flex items-start" data-id="element-482" data-mp="3iww865salmqm">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-483" data-mp="3iw36vkc3rpfv">
                      ✓
                    </div>
                    <div data-id="element-484" data-mp="39zluyevwznj2">Dealing with heavy traffic and adverse weather</div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-485" data-mp="300d4hw09cr1g">
              <PackageCard title="Motorway Driving Lessons" price="£90" description="£45 per hour - 2-hour package for safe and structured lessons to build confidence on motorways." features={['Hands-on experience on actual motorways', 'Learn to manage high-speed driving situations', 'Develop awareness of motorway-specific hazards', 'Build confidence for independent motorway driving']} popular={true} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-486" data-mp="300wcol03w12a" />
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-487" data-mp="2sm3u81a461xf">
          <h2 className="text-2xl font-bold mb-4" data-id="element-488" data-mp="36ek1xfdymo4o">
            Ready to Enhance Your Skills?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-489" data-mp="32cosfnlvl4ft">
            Book your additional lessons today and build the confidence you need
            on the road.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-490" data-mp="3bdwrw904obbh">
            <BeforeYouBook data-id="element-491" data-mp="3bcbu8aiioc9e" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your additional driving lessons in Northampton" data-id="element-492" data-mp="1lyymscf3y842">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default AdditionalLessonsPage;